import { BarChartOut, usageRevenueByUser, UsageRevenueByUserData, UsageQuery } from "@/api";
import { appState } from "@/app/appState";
import { barTable, ChartState, LabelFor } from "../table";
import { useUsageChart } from "../useUsageChart";
import { userRowLabel } from "../views";

const COUNT_PARTS = new Set(["transcriptions", "documents"]);
const partLabel: LabelFor = (item) =>
    appState.t(COUNT_PARTS.has(item.key) ? `usage.kind.${item.key}` : `usage.revenue.${item.key}`);

/**
 * Predicted revenue per user from paying subscribers: seat fees and billed
 * summaries, with the billed transcription and document counts. POST /usage/charts/revenue-by-user
 */
export const useRevenueByUserChart = (query: UsageQuery | undefined): ChartState => {
    const { data, loading, failed } = useUsageChart<UsageRevenueByUserData, BarChartOut>(usageRevenueByUser, query);
    return {
        key: "revenue-by-user",
        title: appState.t("usage.group.revenue"),
        loading,
        failed,
        hint: appState.t("usage.revenueHint"),
        table:
            data &&
            barTable(data, {
                rowLabel: appState.t("usage.user"),
                rowLabelFor: userRowLabel,
                columnLabelFor: partLabel,
            }),
    };
};
